var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoftSharePoint = function SvgMicrosoftSharePoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#036C70",
    d: "M12.232 13.429c3.083 0 5.582-2.559 5.582-5.715C17.814 4.558 15.315 2 12.232 2c-3.082 0-5.58 2.558-5.58 5.714 0 3.156 2.498 5.715 5.58 5.715Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A9BA1",
    d: "M16.884 18.19c2.825 0 5.116-2.345 5.116-5.238 0-2.893-2.29-5.238-5.116-5.238-2.826 0-5.117 2.345-5.117 5.238 0 2.893 2.291 5.238 5.117 5.238Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#37C6D0",
    d: "M12.93 22c2.184 0 3.954-1.812 3.954-4.048 0-2.235-1.77-4.047-3.954-4.047-2.183 0-3.953 1.812-3.953 4.047 0 2.236 1.77 4.048 3.953 4.048Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.163 7.157V17.32a.877.877 0 0 1-.53.805.808.808 0 0 1-.321.067h-3.33c-.005-.081-.005-.158-.005-.239-.002-.08.001-.159.01-.238.084-1.522 1-2.865 2.367-3.471v-.886c-3.041-.493-5.116-3.417-4.634-6.53a4.11 4.11 0 0 1 .108-.54h5.484c.469 0 .85.39.85.87Z",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.846 6.762H6.73c-.517 3.108 1.525 6.056 4.56 6.585.093.016.185.03.277.041-1.441.7-2.492 2.688-2.582 4.326a4.065 4.065 0 0 0-.005.476c.01.16.03.32.061.477h2.805a.857.857 0 0 0 .786-.543.861.861 0 0 0 .065-.329V7.633a.865.865 0 0 0-.85-.871Z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.847 6.762H6.73c-.516 3.108 1.526 6.056 4.561 6.585l.187.03c-1.395.75-2.404 2.733-2.492 4.337h2.86a.868.868 0 0 0 .852-.871v-9.21a.865.865 0 0 0-.851-.871Z",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.381 6.762h-4.65c-.489 2.934 1.307 5.76 4.125 6.491a7.962 7.962 0 0 0-1.87 4.461h2.395c.47-.002.85-.39.851-.871v-9.21a.862.862 0 0 0-.85-.871Z",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#microsoft-share-point_svg__a)",
    d: "M2.853 6.762h8.527c.47 0 .853.39.853.873v8.73a.863.863 0 0 1-.853.873H2.853A.863.863 0 0 1 2 16.365v-8.73c0-.482.382-.873.853-.873Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.658 11.932a1.595 1.595 0 0 1-.488-.528 1.465 1.465 0 0 1-.17-.722c-.01-.341.103-.675.316-.936.225-.262.516-.456.84-.561.37-.125.758-.186 1.148-.182a4.274 4.274 0 0 1 1.512.217v1.095a2.328 2.328 0 0 0-.684-.286 3.256 3.256 0 0 0-.8-.098c-.284-.01-.566.05-.822.178a.552.552 0 0 0-.325.506c0 .133.05.262.14.358.106.113.232.206.371.272a11.646 11.646 0 0 0 .798.357c.305.122.6.27.88.444.212.134.39.318.52.536.132.248.197.527.186.81.015.35-.09.694-.296.974-.206.257-.48.446-.79.545a3.51 3.51 0 0 1-1.128.167 5.821 5.821 0 0 1-1.023-.085 3.442 3.442 0 0 1-.83-.25v-1.155c.254.186.537.324.837.41.3.095.61.146.924.151.29.019.58-.044.837-.182a.578.578 0 0 0 .286-.514.555.555 0 0 0-.158-.393 1.594 1.594 0 0 0-.436-.31c-.186-.096-.46-.222-.822-.377a4.63 4.63 0 0 1-.823-.441Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft-share-point_svg__a",
    x1: 3.778,
    x2: 10.693,
    y1: 6.08,
    y2: 17.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#038489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026D71"
  })))));
};
export default SvgMicrosoftSharePoint;